/**
 * Every list connection a task create/update can reshape.
 *
 * Writing the normalized Task entity is not enough: which connection a task
 * belongs to (and in what order) is decided server-side, so each of these has
 * to be refetched or the edited row stays in its old section until a manual
 * refresh.
 *
 * - `listTasks` backs web Tasks, ProjectSummaryDetail, TaskModal, UserTasks,
 *   ContactTasks and My Tasks' Hero carousel.
 * - `listTasksLight` backs My Tasks' Unscheduled card.
 * - `listMyTasksProjectGroups` backs the mobile My Tasks group cards.
 * - `listProjects` carries the per-project task counts.
 *
 * Shared by TaskFormStack's mutation hook and its per-call override so the two
 * cannot drift apart — dropping `listTasks` from one of them is exactly what
 * left an edited task under the wrong section (TA-10495 code review).
 */
export const TASK_LIST_REFETCH_QUERY_NAMES = [
  'listTasks',
  'listTasksLight',
  'listMyTasksProjectGroups',
  'listProjects',
] as const;
